module.exports = __webpack_public_path__ + "static/img/logo36.ec56fc2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo36.png
// module id = ga0+
// module chunks = 1